module.exports = __webpack_public_path__ + "static/media/embarrassed.cc422fe9.svg";